import * as React from 'react';
import { Datagrid, DateField, List, TextField, TextInput } from 'react-admin';
import { WrappedWithBackButton } from '../../common/wrapped-with-back-button';

const filters = [
    <TextInput
        source="query"
        label={'Keresés'}
        name={'query'}
        fullWidth
        alwaysOn
        key={1}
    />,
];

export const UniqueRequestTemplateList = () => {
    return (
        <WrappedWithBackButton redirect={'/unique-request'}>
            <List
                title={'Bejelentések'}
                sort={{ field: 'CreatedAt', order: 'DESC' }}
                filters={filters}
            >
                <Datagrid rowClick={'show'} bulkActionButtons={false}>
                    <TextField source={'name'} label={'Elnevezés'} />
                    <DateField
                        source="createdAt"
                        locales={['hu-HU']}
                        label={'Létrehozva'}
                        showTime
                    />
                    <DateField
                        source="updatedAt"
                        locales={['hu-HU']}
                        label={'Módosítva'}
                        showTime
                    />
                </Datagrid>
            </List>
        </WrappedWithBackButton>
    );
};
